import { memo } from 'react';
import { Box, Typography, Paper, Button } from '@mui/material';

function CtaBanner({ colors, user, navigate }) {
  return (
        <Box id="home-cta"
          sx={{ 
            py: { xs: 6, md: 8 },
            mb: 6,
          }}
        >
          <Paper
            elevation={0}
            sx={{
              bgcolor: colors.bgPaper,
              border: `1px solid ${colors.border}`,
              borderRadius: 3,
              p: { xs: 4, md: 6 },
              textAlign: 'center',
              position: 'relative',
              overflow: 'hidden',
            }}
          >
            <Box sx={{
              position: 'absolute',
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              background: 'radial-gradient(circle at 50% 50%, rgba(129,140,248,0.1) 0%, transparent 70%)',
              pointerEvents: 'none',
            }} />

            <Box sx={{ position: 'relative', zIndex: 1 }}>
              <Typography 
                variant="h4" 
                sx={{ 
                  fontWeight: 700,
                  mb: 2,
                  color: colors.textPrimary,
                  fontSize: { xs: '1.75rem', md: '2rem' },
                }}
              >
                Prêt à récupérer ce que votre musique génère ?
              </Typography>
              <Typography 
                variant="body1" 
                sx={{ 
                  color: colors.textSecondary,
                  mb: 4,
                  maxWidth: '600px',
                  mx: 'auto',
                }}
              >
                Rejoignez les artistes et producteurs qui sécurisent déjà leurs déclarations avec Publy Music.
              </Typography>
              <Button
                variant="contained"
                size="large"
                onClick={() => navigate(user ? '/documents' : '/register')}
                sx={{
                  bgcolor: colors.primaryLight,
                  px: 5,
                  py: 2,
                  fontSize: '1.1rem',
                  fontWeight: 600,
                  textTransform: 'none',
                  borderRadius: 2,
                  '&:hover': {
                    bgcolor: colors.primaryLight,
                    transform: 'translateY(-2px)',
                    boxShadow: '0 8px 24px rgba(129,140,248,0.4)',
                  },
                  transition: 'all 0.2s',
                }}
              >
                {user ? 'Continuer mes déclarations' : 'Créer mon compte gratuitement'}
              </Button>
            </Box>
          </Paper>
        </Box>
  );
}

export default memo(CtaBanner);
